import { IncidentModel } from './incident.model';
export class FailedVisionModel extends IncidentModel {

}
